import React from 'react';

/** Spinner **/
import { BounceLoader } from 'react-spinners';

export default () => {
  return (<BounceLoader
          css={`display: block; margin: 0 auto; border-color: red;`}
          sizeUnit={"px"}
          size={100}
          color={'#4890cb'}
          loading={true}
      />);
};



// WEBPACK FOOTER //
// ./src/components/common/Spinner.js